import React, { Component } from "react";
import PropTypes from "prop-types";
import HelloSign from "hellosign-embedded";
import { authHttpFactory } from "../../apiConfig";
import accessErrorFactory from "./accessErrorFactory";
import SigningDocuments from "./signingDocuments";

const propTypes = {
  signingId: PropTypes.string.isRequired,
  setLoading: PropTypes.func.isRequired,
  blockPage: PropTypes.func.isRequired,
  showAlert: PropTypes.func.isRequired,
  hideAlert: PropTypes.func.isRequired,
};

class EmbeddedSignature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: null,
      pollingDocuments: false,
    };

    this.http = authHttpFactory(props.signingId);
  }

  componentDidMount() {
    this.getEmbeddedSigningData(this.props.signingId);
  }

  getEmbeddedSigningData(signingId) {
    this.props.setLoading(true);

    this.http.get(`/signing/${signingId}/embedded`).then(
      (response) => {
        this.props.setLoading(false);

        if (response.status === 200) {
          if (response.data.documentStatus === "Unsigned") {
            this.setupIframe(response.data.clientId, response.data.signingUrl);
            return;
          }

          if (response.data.documentStatus === "Disabled") {
            return;
          }

          if (!response.data.documents) {
            this.doPolling();
            return;
          }

          this.stopPolling();
          this.setState({
            documents: response.data.documents,
          });
        }
      },
      (err) => {
        this.props.setLoading(false);

        const error = accessErrorFactory(err);
        if (!error) {
          return;
        }

        this.props.showAlert(error.message, "error");
        if (error.blocking) {
          this.props.blockPage();
        }
      }
    );
  }

  setupIframe(clientId, signingUrl) {
    const helloSignClient = new HelloSign({
      clientId,
      allowCancel: false,
      skipDomainVerification: window.env.SKIP_DROPBOX_DOMAIN_VERIFICATION,
    });

    helloSignClient.on("message", (data) => {
      if (data.type === "hellosign:userDeclineRequest") {
        this.declineSignature();
        return;
      }

      if (data.type === "hellosign:userSignRequest") {
        this.completeSignature();
      }
    });

    helloSignClient.open(signingUrl);

    window.addEventListener("beforeunload", () => { helloSignClient.close() });
  }

  completeSignature() {
    this.http
      .post(`/signing/${this.props.signingId}/embedded/complete`, null)
      .then(() => {
        this.getEmbeddedSigningData(this.props.signingId);
      });
  }

  declineSignature() {
    this.http
      .post(`/signing/${this.props.signingId}/embedded/decline`, null)
      .then(() => {
        this.props.showAlert("The document is no longer available.", "error");
        this.props.blockPage();
      });
  }

  doPolling() {
    if (!this.state.pollingDocuments) {
      this.props.showAlert(
        "Signed documents will be provided shortly. Please wait.",
        "info",
        false
      );
      this.setState({ pollingDocuments: true });
    }
    this.props.setLoading(true);
    setTimeout(() => this.getEmbeddedSigningData(this.props.signingId), 3000);
  }

  stopPolling() {
    this.setState({ pollingDocuments: false });
    this.props.hideAlert();
  }

  render() {
    if (!this.state.documents) {
      return <div />;
    }

    return (
      <SigningDocuments
        signingId={this.props.signingId}
        items={this.state.documents}
      />
    );
  }
}

EmbeddedSignature.propTypes = propTypes;
export default EmbeddedSignature;
